import React, { useRef, useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface FileUploaderProps {
  name: string;
  onFileUpload: (file: File | null, name:string) => void; // Callback per gestire il file caricato
  acceptedTypes?: string[]; // Tipi di file accettati (es. ["application/pdf", "image/png"])
  error:boolean;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  onFileUpload,
  acceptedTypes,
  name,
 error
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;

    if (file && acceptedTypes && !acceptedTypes.includes(file.type)) {
      toast.warning(
        <>
          Formato file non supportato! <br />
          File supportati: <strong>PDF, PNG, JPEG</strong>
        </>,
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }

    setSelectedFile(file);
    onFileUpload(file, name);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    onFileUpload(null, name);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
console.log('error',error)
  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedTypes?.join(",")}
        style={{ display: "none" }}
        id={`file-input-${name}`}
        onChange={handleFileChange}
      />
      {!selectedFile && (
        <label htmlFor={`file-input-${name}`} style={{ width: "100%" }}>
          <Button
            component="span"
            variant="outlined"
            endIcon={<AddRounded />}
            fullWidth
            sx={{
              textTransform: "none",
              borderColor:error?'#CF0A2C':'gray',
              color: "gray",
              width: "100%",
              borderRadius: "7px",
              display: "flex", // Imposta flexbox
              justifyContent: "space-between", // Separa testo e icona
              alignItems: "center",
              height: "41.5px", // Allinea verticalmente
            }}
          >
            {t("common.sidebars.addVehicle.addVehicleDocument")}
          </Button>
        </label>
      )}
      {selectedFile && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            columnGap:'8px'
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              textDecoration: "underline",
              color: "#CF0A2C",
            }}
          >
            {selectedFile.name}
          </Typography>
        
          <IconButton onClick={handleRemoveFile}>
          <DeleteIcon color="error" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default FileUploader;
